var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.isLoading)?_c('Preloader'):_vm._e()],1),_c('Navbar',{attrs:{"offset-top":_vm.navOffsetTop,"logoUrl":_vm.siteInfo.logoUrl,"nav-links":_vm.siteInfo.navLinks}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }